export default __webpack_public_path__ + "static/media/02.6d910f0c.svg";